import React, { Component, PropTypes } from 'react';
import join from 'url-join';
import Link from 'react-router/lib/Link';

const recruitsText = (total, unmapped) => {
  let recruitsText = (total === 1 ? 'recruit' : 'recruits');
  if (total === 0) {
    return `${total} ${recruitsText}`;
  } else {
    return `${total} ${recruitsText} / ${unmapped} unassigned`;
  }
};

export default class TourneyRecruitStatusButton extends Component {

  getHref() {
    const { tourney } = this.props;
    return join('tourneys', tourney.id, 'attendance');
  }

  getProperties() {
    let properties;
    const { tourney } = this.props;
    const { numRecruits, numRecruitsWithTeams } = tourney;
    const unmapped = (numRecruits - numRecruitsWithTeams);

    if (numRecruits === 0) {
      properties = {
        text: recruitsText(numRecruits, unmapped)
      };
    } else if (numRecruits === numRecruitsWithTeams) {
      properties = {
        type: 'success',
        text: recruitsText(numRecruits, unmapped)
      };
    } else {
      properties = {
        type: 'warning',
        text: recruitsText(numRecruits, unmapped)
      };
    }

    return properties;
  }

  render() {
    return (
      <Link
        className={`display-inline-block color-${this.getProperties().type}`}
        to={this.getHref()}
      >
        {this.getProperties().text}
      </Link>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/buttons/TourneyRecruitStatusButton.jsx